module.exports = __webpack_public_path__ + "static/media/JS.cf03f1a0.png";